import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { StoreStatistic } from '@app/models'
import { api } from '@services'

import { RootState } from 'AppTypes'

export const initialState = {
  isLoading: false,
  featureInitialed: 'pending',
  storeStatistic: {} as StoreStatistic
}

/* eslint no-debugger: "off" */
export const initFeature = createAsyncThunk(
  'dashboard/init',
  async (_, thunkAPI) => {
    const currentStoreUser = (thunkAPI.getState() as RootState).app.currentStoreUser
    const storeStatistic = await api.store.fetchStoreStatistic(currentStoreUser.currentStoreId)
    return storeStatistic
  }
)

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    //
  },
  extraReducers: builder => {
    builder.addCase(initFeature.pending, state => {
      state.featureInitialed = 'pending'
      state.isLoading = true
    })
    builder.addCase(initFeature.fulfilled, (state, action) => {
      state.storeStatistic = action.payload
      state.isLoading = false
      state.featureInitialed = 'fulfilled'
    })
    builder.addCase(initFeature.rejected, state => {
      state.isLoading = false
      state.featureInitialed = 'rejected'
    })
  }
})

export default dashboardSlice.reducer
